import { PaymentElement } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import "./style.css";



export default function StripeCheckoutForm(props) {
    const { tentativeOrder } = props
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();

    const [message, setMessage] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);

    // const tentativeOrder = useSelector((state) => state.payment.tentativeOrder);

    const currencySymbol = tentativeOrder.currencySymbol;
    const amount = tentativeOrder.grandTotal;

    const handleStripeSubmit = async (e) => {
        try {
            e.preventDefault();
            if (!stripe || !elements) {
                return;
            }

            setIsProcessing(true);
            setMessage("");
            const confirmPaymentStatus = await stripe.confirmPayment({
                elements,
                redirect: "if_required",
            });

            if (
                confirmPaymentStatus.paymentIntent &&
                confirmPaymentStatus.paymentIntent.id &&
                confirmPaymentStatus.paymentIntent.status === "succeeded"
            ) {
                console.log("STRIPE PAYMENT", confirmPaymentStatus);
                setTimeout(async () => {
                    setIsProcessing(false);
                    handleRedirectionForStripe(confirmPaymentStatus)
                }, 5000);
            }
            else {
                if (confirmPaymentStatus.error) {
                    alert(confirmPaymentStatus.error.message);
                    navigate("/")
                }
            }
        } catch (err) {
            alert("Error coming from handleStripeSubmit()", err);
            navigate("/")
        }
    };


    const handleRedirectionForStripe = async (confirmPaymentStatus) => {
        props.handlePaymentSuccess(confirmPaymentStatus.paymentIntent.id)
    }


    const formLoaded = () => {

    };

    return (
        <div className="stripeCheckoutForm">
            <form id="payment-form" onSubmit={handleStripeSubmit} onLoad={formLoaded}>
                <p className="orderAmount">Pay  {currencySymbol}{amount}</p>
                {message !== "" && <p class="paymentErrMessage">{message}</p>}
                <PaymentElement id="payment-element" />
                <button disabled={isProcessing || !stripe || !elements} id="submit">
                    <span id="button-text">
                        {isProcessing ? "Processing ... " : "Pay now"}
                    </span>
                </button>
            </form>
        </div>
    );
}
